$(document).ready(function () {
  if ($(window).width() >= 1024) {
    // About Page
    var $element_1 = $(".about-title--image-02");
    var windowHeight = $(window).height();

    if ($element_1.length) {
      var elementOffset_1 = $element_1.offset().top;
      function updateTransform_1() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_1) /
          (windowHeight + $element_1.height()); // Percentage of how much element is in view

        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        var translateY = 15.6065 + scrollPercent * 34.39;
        var rotateZ = -14.0459 + scrollPercent * -30;

        $element_1.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_1);
    }

    var $element_2 = $(".about-title--image-03");

    if ($element_2.length) {
      var elementOffset_2 = $element_2.offset().top;

      function updateTransform_2() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_2) /
          (windowHeight + $element_2.height()); // Percentage of how much element is in view

        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        var translateY = 46.8165 + scrollPercent * 103.1685;
        var rotateZ = 9.3633 + scrollPercent * 20.6337;

        $element_2.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_2);
    }

    var $element_3 = $(".our-company-image-01");

    if ($element_3.length) {
      var elementOffset_3 = $element_3.offset().top;

      // Function to update transform based on scroll
      function updateTransform_3() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_3) /
          (windowHeight + $element_3.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY and rotateZ values based on the scrollPercent
        var translateY = -50 + scrollPercent * 100; // Start from -50px and go up to +50px
        var rotateZ = -15 + scrollPercent * 30; // Start from -15deg and rotate to +15deg

        // Apply the transformation to the element
        $element_3.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_3);
    }

    var $element_4 = $(".our-company-image-02");
    if ($element_4.length) {
      var elementOffset_4 = $element_4.offset().top;

      // Function to update transform based on scroll
      function updateTransform_4() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_4) /
          (windowHeight + $element_4.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY and rotateZ values based on the scrollPercent
        var translateY = -150 + scrollPercent * 299.976; // Start from -150px and go up to +149.976px
        var rotateZ = -20 + scrollPercent * 39.9968; // Start from -20deg and rotate to +19.9968deg

        // Apply the transformation to the element
        $element_4.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_4);
    }

    var $element_5 = $(".our-company-image-03");
    if ($element_5.length) {
      var elementOffset_5 = $element_5.offset().top;

      // Function to update transform based on scroll
      function updateTransform_5() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_5) /
          (windowHeight + $element_5.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY and rotateZ values based on the scrollPercent
        var translateY = -100 + scrollPercent * 199.984; // Start from -100px and go up to +99.984px
        var rotateZ = -15 + scrollPercent * 29.9976; // Start from -15deg and rotate to +14.9976deg

        // Apply the transformation to the element
        $element_5.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_5);
    }

    var $element_6 = $(".our-company-image-04");
    if ($element_6.length) {
      var elementOffset_6 = $element_6.offset().top;

      // Function to update transform based on scroll
      function updateTransform_6() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_6) /
          (windowHeight + $element_6.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY and rotateZ values based on the scrollPercent
        var translateY = -75 + scrollPercent * 149.991; // Start from -75px and go up to +74.991px
        var rotateZ = 10 + scrollPercent * -19.9988; // Start from 10deg and rotate to -9.9988deg

        // Apply the transformation to the element
        $element_6.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_6);
    }

    var $element_7 = $(".our-company-image-05");
    if ($element_7.length) {
      var elementOffset_7 = $element_7.offset().top;

      // Function to update transform based on scroll
      function updateTransform_7() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_7) /
          (windowHeight + $element_7.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY and rotateZ values based on the scrollPercent
        var translateY = -150 + scrollPercent * 299.982; // Start from -150px and go up to +149.982px
        var rotateZ = 15 + scrollPercent * -29.9982; // Start from 15deg and rotate to -14.9982deg

        // Apply the transformation to the element
        $element_7.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_7);
    }

    var $element_8 = $(".our-company-image-06");
    if ($element_8.length) {
      var elementOffset_8 = $element_8.offset().top;

      // Function to update transform based on scroll
      function updateTransform_8() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_8) /
          (windowHeight + $element_8.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY and rotateZ values based on the scrollPercent
        var translateY = -75 + scrollPercent * 149.9865; // Start from -75px and go up to +74.9865px
        var rotateZ = 5 + scrollPercent * -9.9991; // Start from 5deg and rotate to -4.9991deg

        // Apply the transformation to the element
        $element_8.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_8);
    }

    var $element_9 = $(".our-company-image-07");
    if ($element_9.length) {
      var elementOffset_9 = $element_9.offset().top;

      // Function to update transform based on scroll
      function updateTransform_9() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_9) /
          (windowHeight + $element_9.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate the translateY value based on the scrollPercent
        var translateY = -200 + scrollPercent * 399.964; // Start from -200px and go up to +199.964px

        // Apply the transformation to the element
        $element_9.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_9);
    }

    var $element_10 = $(".founders-story-image-01");
    if ($element_10.length) {
      var elementOffset_10 = $element_10.offset().top;

      // Function to update transform based on scroll
      function updateTransform_10() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_10) /
          (windowHeight + $element_10.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY and rotateZ values based on scrollPercent
        var translateY = -50 + scrollPercent * 99.992; // Start from -50px and move to +49.992px
        var rotateZ = -10 + scrollPercent * 19.9984; // Start from -10deg and rotate to +9.9984deg

        // Apply the transformation to the element
        $element_10.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_10);
    }

    var $element_11 = $(".founders-story-image-02");
    if ($element_11.length) {
      var elementOffset_11 = $element_11.offset().top;

      // Function to update transform based on scroll
      function updateTransform_11() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_11) /
          (windowHeight + $element_11.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY and rotateZ values based on scrollPercent
        var translateY = -150 + scrollPercent * 299.982; // Start from -150px and move to +149.982px
        var rotateZ = 10 + scrollPercent * -19.9988; // Start from +10deg and rotate to -9.9988deg

        // Apply the transformation to the element
        $element_11.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_11);
    }

    var $element_12 = $(".founders-story-image-03");
    if ($element_12.length) {
      var elementOffset_12 = $element_12.offset().top;

      // Function to update transform based on scroll
      function updateTransform_12() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_12) /
          (windowHeight + $element_12.height()); // Percentage of how much element is in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY and rotateZ values based on scrollPercent
        var translateY = -75 + scrollPercent * 149.988; // Start from -75px and move to +74.988px
        var rotateZ = 15 + scrollPercent * -29.9976; // Start from +15deg and rotate to -14.9976deg

        // Apply the transformation to the element
        $element_12.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_12);
    }

    var $element_13 = $(".founders-story-image-04");
    if ($element_13.length) {
      var elementOffset_13 = $element_13.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_13() {
        var scrollTop = $(window).scrollTop();
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_13) /
          (windowHeight + $element_13.height()); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY and rotateZ values based on scrollPercent
        var translateY = -30 + scrollPercent * 59.9952; // From -30px to 29.9952px
        var rotateZ = -10 + scrollPercent * 19.9984; // From -10deg to 9.9984deg

        // Apply the calculated transform
        $element_13.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }
      $(window).on("scroll", updateTransform_13);
    }

    var $image = $(".always-improving-image");
    var $image_2 = $(".about-title--right");
    var $image_3 = $(".boring-spices--image");
    var $image_4 = $(".boring-spices--title");

    if ($image.length && $image_2.length) {
      var elementOffset = $image.offset().top;
      var imageHeight = $image.height();

      var elementOffset_2 = $image_2.offset().top;
      var imageHeight_2 = $image_2.height();

      var windowHeight = $(window).height(); // Get the window height

      // Function to check if the element is in the viewport
      function isInView(elementOffset, imageHeight) {
        var scrollTop = $(window).scrollTop();
        var scrollBottom = scrollTop + windowHeight;

        // Check if the element is in view (partially or fully)
        return (
          scrollBottom > elementOffset &&
          scrollTop < elementOffset + imageHeight
        );
      }

      // Function to apply the transformation
      function applyTransform() {
        // Check if $image is in the viewport
        if (isInView(elementOffset, imageHeight)) {
          $image.css({
            opacity: "1",
            transform: "translate3d(0px, 0px, 0px)", // Move to original position
          });
        }

        // Check if $image_2 is in the viewport
        if (isInView(elementOffset_2, imageHeight_2)) {
          $image_2.css({
            opacity: "1",
            transform: "translate3d(0px, 0px, 0px)", // Move to original position
          });
        }
      }
      applyTransform();

      $(window).on("scroll", applyTransform);
    }

    if ($image_3.length && $image_4.length) {
      var elementOffset_3 = $image_3.offset().top;
      var imageHeight_3 = $image_3.height();
      var elementOffset_4 = $image_3.offset().top;
      var imageHeight_4 = $image_3.height();
      var windowHeight = $(window).height();
      function isInView(elementOffset, imageHeight) {
        var scrollTop = $(window).scrollTop();
        var scrollBottom = scrollTop + windowHeight;

        // Check if the element is in view (partially or fully)
        return (
          scrollBottom > elementOffset &&
          scrollTop < elementOffset + imageHeight
        );
      }
      function applyTransform() {
        // Check if $image is in the viewport
        if (isInView(elementOffset_3, imageHeight_3)) {
          $image_3.css({
            opacity: "1",
            transform: "translate3d(0px, 0px, 0px)", // Move to original position
          });
        }
        if (isInView(elementOffset_4, imageHeight_4)) {
          $image_4.css({
            opacity: "1",
            transform: "translate3d(0px, 0px, 0px)", // Move to original position
          });
        }
      }
      applyTransform();

      $(window).on("scroll", applyTransform);
    }

    // Pepper Page

    var $element_14 = $(".chili-pepper-lineup--image");

    if ($element_14.length) {
      var elementOffset_14 = $element_14.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_14() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_14) /
          (windowHeight + $element_14.height()); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 30.317 + scrollPercent * 69.673; // From 30.317px to 99.99px

        // Apply the calculated transform
        $element_14.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_14);
    }

    // Howie Page
    var $element_15 = $(".the-power--title-image-01");

    if ($element_15.length) {
      var elementOffset_15 = $element_15.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_15() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_15) /
          (windowHeight + $element_15.height()); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 30.317 + scrollPercent * 69.673; // From 30.317px to 99.99px

        // Apply the calculated transform
        $element_15.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_15);
    }

    var $element_16 = $(".the-power--title-image-02"); // Target your image

    if ($element_16.length) {
      var elementOffset_16 = $element_16.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_16() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_16) /
          (windowHeight + $element_16.height()); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = -0.007 + scrollPercent * 100;

        // Apply the calculated transform
        $element_16.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_16);
    }

    $(".floating-gridner-06").each(function () {
      var $element_17 = $(this); // 'this' refers to the current element in the loop
      var elementOffset_17 = $element_17.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_17() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_17) /
          (windowHeight + $element_17.height() + 811); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 99.988 * scrollPercent; // From 0px to 99.988px

        // Calculate rotateZ value based on scrollPercent
        var rotateZ = -15 * (1 - scrollPercent); // From -15deg to 0deg

        // Apply the calculated transform
        $element_17.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_17);
    });

    $(".floating-gridner-05").each(function () {
      var $element_18 = $(this); // 'this' refers to the current element in the loop
      var elementOffset_18 = $element_18.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_18() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_18) /
          (windowHeight + $element_18.height() + 811); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 124.985 * scrollPercent; // From 0px to 124.985px

        // Calculate rotateZ value based on scrollPercent
        var rotateZ = -15 * (1 - scrollPercent); // From -15deg to 0deg

        // Apply the calculated transform
        $element_18.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_18);
    });

    $(".floating-gridner-04").each(function () {
      var $element_19 = $(this); // 'this' refers to the current element in the loop
      var elementOffset_19 = $element_19.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_19() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_19) /
          (windowHeight + $element_19.height() + 811 ); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 74.9895 * scrollPercent; // From 0px to 74.9895px

        // Calculate rotateZ value based on scrollPercent
        var rotateZ = -15 * (1 - scrollPercent); // From -15deg to 0deg

        // Apply the calculated transform
        $element_19.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_19);
    });

    $(".floating-gridner-03").each(function () {
      var $element_20 = $(this); // 'this' refers to the current element in the loop
      var elementOffset_20 = $element_20.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_20() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_20) /
          (windowHeight + $element_20.height() + 811 ); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 149.97 * scrollPercent; // From 0px to 149.97px

        // Calculate rotateZ value based on scrollPercent
        var rotateZ = -15 * (1 - scrollPercent); // From -15deg to 0deg

        // Apply the calculated transform
        $element_20.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_20);
    });

    $(".floating-gridner-02").each(function () {
      var $element_21 = $(this); // 'this' refers to the current element in the loop
      var elementOffset_21 = $element_21.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_21() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_21) /
          (windowHeight + $element_21.height() + 811 ); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 74.985 * scrollPercent; // From 0px to 74.985px

        // Calculate rotateZ value based on scrollPercent
        var rotateZ = -15 * (1 - scrollPercent); // From -15deg to 0deg

        // Apply the calculated transform
        $element_21.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_21);
    });

    $(".floating-gridner-01").each(function () {
      var $element_22 = $(this); // 'this' refers to the current element in the loop
      var elementOffset_22 = $element_22.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_22() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_22) /
          (windowHeight + $element_22.height() + 811 ); // Percentage of the element in view

        // Clamp the scrollPercent to be between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 74.985 * scrollPercent; // From 0px to 74.985px

        // Calculate rotateZ value based on scrollPercent
        var rotateZ = -15 * (1 - scrollPercent); // From -15deg to 0deg

        // Apply the calculated transform
        $element_22.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(" +
            rotateZ +
            "deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_22);
    });

    $(window).on('scroll', function() {
      $('.dot').each(function() {
            var dot = $(this);
            var windowBottom = $(window).scrollTop() + $(window).height();
            var dotOffset = dot.offset().top;
            var dotHeight = dot.height();

            if (windowBottom >= dotOffset + (dotHeight * 0.15)) {
                // Delay the growing effect and apply it
                dot.delay(0).queue(function(next) {
                    dot.addClass('grow');
                    next();
                });
            } else {
                dot.removeClass('grow');
            }
        });
      
        $('.tz-left-sroll').each(function() {
            var dot = $(this);
            var windowBottom = $(window).scrollTop() + $(window).height();
            var dotOffset = dot.offset().top;
            var dotHeight = dot.height();

            if (windowBottom >= dotOffset + (dotHeight * 0.15)) {
                // Delay the growing effect and apply it
                dot.delay(0).queue(function(next) {
                    dot.addClass('tz-scroll-active');
                    next();
                });
            } else {
                dot.removeClass('tz-scroll-active');
            }
        });
        $('.tz-right-sroll').each(function() {
              var dot = $(this);
              var windowBottom = $(window).scrollTop() + $(window).height();
              var dotOffset = dot.offset().top;
              var dotHeight = dot.height();
  
              if (windowBottom >= dotOffset + (dotHeight * 0.15)) {
                  // Delay the growing effect and apply it
                  dot.delay(0).queue(function(next) {
                      dot.addClass('tz-scroll-active');
                      next();
                  });
              } else {
                  dot.removeClass('tz-scroll-active');
              }
          });
    });
    
    // Home Page

    var $element_23 = $(".spice-explosion");

    if ($element_23.length) {
      var elementOffset_23 = $element_23.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_23() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_23) /
          (windowHeight + $element_23.height());

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate scale value based on scrollPercent
        var scale = scrollPercent; // Scale from 0 to 1

        // Calculate opacity based on scrollPercent
        var opacity = scrollPercent; // Opacity goes from 0 to 1

        // Apply the calculated transform and opacity
        $element_23
          .css(
            "transform",
            "translate3d(0px, 0px, 0px) scale3d(" +
              scale +
              ", " +
              scale +
              ", 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
          )
          .css("opacity", opacity);
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_23);
    }

    var $element_24 = $(".spice-explosion-banner");

    if ($element_24.length) {
      var elementOffset_24 = $element_24.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_24() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_24) /
          (windowHeight + $element_24.height());

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate scale value based on scrollPercent
        var scale = scrollPercent; // Scale from 0 to 1

        // Calculate opacity based on scrollPercent
        var opacity = scrollPercent; // Opacity goes from 0 to 1

        $element_24
          .css(
            "transform",
            "translate3d(0px, 0px, 0px) scale3d(" +
              scale +
              ", " +
              scale +
              ", 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
          )
          .css("opacity", opacity);
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_24);
    }

    var $element_25 = $(".tz-bottom-image");

    if ($element_25.length) {
      var elementOffset_25 = $element_25.offset().top; // Get the element's top offset

      // Function to update the opacity property on scroll
      function updateOpacity_25() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_25) /
          (windowHeight + $element_25.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Apply the calculated opacity
        $element_25.css("opacity", scrollPercent);
      }

      // Call the function on scroll
      $(window).on("scroll", updateOpacity_25);
    }

    var $element_26 = $(".grinders-chillies-05");

    if ($element_26.length) {
      var elementOffset_26 = $element_26.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_26() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_26) /
          (windowHeight + $element_26.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 8.77 * scrollPercent; // From -100px to 8.77px

        // Apply the calculated transform immediately (no delay)
        $element_26.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_26);
    }

    var $element_27 = $(".grinders-chillies-04");

    if ($element_27.length) {
      var elementOffset_27 = $element_27.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_27() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_27) /
          (windowHeight + $element_27.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 99.986 * scrollPercent; // From -100px to 99.986px

        // Apply the calculated transform immediately (no delay)
        $element_27.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_27);
    }

    var $element_28 = $(".grinders-chillies-03");

    if ($element_28.length) {
      var elementOffset_28 = $element_28.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_28() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_28) /
          (windowHeight + $element_28.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 49.991 * scrollPercent; // From -50px to 49.991px

        // Apply the calculated transform immediately (no delay)
        $element_28.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_28);
    }

    var $element_29 = $(".grinders-chillies-02");

    if ($element_29.length) {
      var elementOffset_29 = $element_29.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_29() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_29) /
          (windowHeight + $element_29.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 149.973 * scrollPercent; // From -150px to 149.973px

        // Apply the calculated transform immediately (no delay)
        $element_29.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_29);
    }

    var $element_30 = $(".grinders-chillies-01");

    if ($element_30.length) {
      var elementOffset_30 = $element_30.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_30() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_30) /
          (windowHeight + $element_30.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 74.9895 * scrollPercent; // From -75px to 74.9895px

        // Apply the calculated transform immediately (no delay)
        $element_30.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_30);
    }

    var $element_31 = $(".chili-flakes");

    if ($element_31.length) {
      var elementOffset_31 = $element_31.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_31() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_31) /
          (windowHeight + $element_31.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 49.994 * scrollPercent; // From -50px to 49.994px

        // Apply the calculated transform immediately (no delay)
        $element_31.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_31);
    }

    const $grinder = $('.grinder-breakdown');
    const $grinderFull = $('.grinder-breakdown-full');
  
    if ($grinder.length && $grinderFull.length ) {
    const elementTop = $grinder.offset().top;
    const elementHeight = $grinder.outerHeight();  
    function updateOpacity() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      
      // Calculate visibility progress (0 to 1)
      const scrollStart = elementTop - windowHeight + 1200 ;
      const scrollEnd = elementTop + elementHeight;
      let progress = (scrollTop - scrollStart) / (scrollEnd - scrollStart);
      
      // Clamp progress between 0 and 1
      progress = Math.min(1, Math.max(0, progress));
      
      // Apply calculated opacities
      $grinder.css('opacity', 1 - progress);
      $grinderFull.css('opacity', progress);
    }
  
    // Throttle scroll events for better performance
    $(window).on('scroll', updateOpacity);
    updateOpacity(); // Initial check
    }
      
    // var $element_32 = $(".grinder-breakdown");

    // if ($element_32.length) {
    //   var elementOffset_32 = $element_32.offset().top; // Get the element's top offset

    //   // Function to update the opacity property on scroll
    //   function updateOpacity_32() {
    //     var scrollTop = $(window).scrollTop();
    //     var windowHeight = $(window).height();

    //     // Calculate scroll percentage (how much of the element is in view)
    //     var scrollPercent =
    //       (scrollTop + windowHeight - elementOffset_32) /
    //       (windowHeight + $element_32.height() + 811);

    //     // Clamp the scrollPercent between 0 and 1
    //     scrollPercent = Math.min(1, Math.max(0, scrollPercent));

    //     // Apply the calculated opacity
    //     $element_32.css("opacity", scrollPercent);
    //   }

    //   // Call the function on scroll
    //   $(window).on("scroll", updateOpacity_32);
    // }

    // var $element_33 = $(".grinder-breakdown-full");

    // if ($element_33.length) {
    //   var elementOffset_33 = $element_33.offset().top; // Get the element's top offset

    //   // Function to update the opacity property on scroll
    //   function updateOpacity_33() {
    //     var scrollTop = $(window).scrollTop();
    //     var windowHeight = $(window).height();

    //     // Calculate scroll percentage (how much of the element is in view)
    //     var scrollPercent =
    //       (scrollTop + windowHeight - elementOffset_33) /
    //       (windowHeight + $element_33.height() + 811);

    //     // Clamp the scrollPercent between 0 and 1
    //     scrollPercent = Math.min(1, Math.max(0, scrollPercent));

    //     // Apply the calculated opacity
    //     $element_33.css("opacity", scrollPercent);
    //   }

    //   // Call the function on scroll
    //   $(window).on("scroll", updateOpacity_33);
    // }

    var $element_34 = $(".refills-01");

    if ($element_34.length) {
      var elementOffset_34 = $element_34.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_34() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_34) /
          (windowHeight + $element_34.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 199.976 * scrollPercent; // From -100px to 199.976px

        // Apply the calculated transform immediately (no delay)
        $element_34.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_34);
    }

    var $element_35 = $(".refills-02");

    if ($element_35.length) {
      var elementOffset_35 = $element_35.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_35() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_35) /
          (windowHeight + $element_35.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 64.9896 * scrollPercent; // From -65px to 64.9896px

        // Apply the calculated transform immediately (no delay)
        $element_35.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_35);
    }

    var $element_36 = $(".refills-03");

    if ($element_36.length) {
      var elementOffset_36 = $element_36.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_36() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_36) /
          (windowHeight + $element_36.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 149.97 * scrollPercent; // From -150px to 149.97px

        // Apply the calculated transform immediately (no delay)
        $element_36.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_36);
    }

    var $element_37 = $(".refills-04");

    if ($element_37.length) {
      var elementOffset_37 = $element_37.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_37() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_37) /
          (windowHeight + $element_37.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 99.984 * scrollPercent; // From -100px to 99.984px

        // Apply the calculated transform immediately (no delay)
        $element_37.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(-30deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_37);
    }

    var $element_38 = $(".refills-05");

    if ($element_38.length) {
      var elementOffset_38 = $element_38.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_38() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_38) /
          (windowHeight + $element_38.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 99.984 * scrollPercent; // From -100px to 99.984px

        // Apply the calculated transform immediately (no delay)
        $element_38.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_38);
    }

    var $element_39 = $(".spicequest-6-tube");

    if ($element_39.length) {
      var elementOffset_39 = $element_39.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_39() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_39) /
          (windowHeight + $element_39.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 64.987 * scrollPercent; // From -65px to 64.987px

        // Apply the calculated transform immediately (no delay)
        $element_39.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_39);
    }

    var $element_40 = $(".spicequest-7-tube");

    if ($element_40.length) {
      var elementOffset_40 = $element_40.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_40() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_40) /
          (windowHeight + $element_40.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 44.991 * scrollPercent; // From -45px to 44.991px

        // Apply the calculated transform immediately (no delay)
        $element_40.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_40);
    }

    var $element_41 = $(".spicequest-2-box");

    if ($element_41.length) {
      var elementOffset_41 = $element_41.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_41() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_41) /
          (windowHeight + $element_41.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 24.9955 * scrollPercent; // From -25px to 24.9955px

        // Apply the calculated transform immediately (no delay)
        $element_41.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_41);
    }

    // var $element_42 = $(".grinder-rack-outline");

    // if ($element_42.length) {
    //   var elementOffset_42 = $element_42.offset().top; // Get the element's top offset

    //   // Function to update the opacity property on scroll
    //   function updateOpacity_42() {
    //     var scrollTop = $(window).scrollTop();
    //     var windowHeight = $(window).height();

    //     // Calculate scroll percentage (how much of the element is in view)
    //     var scrollPercent =
    //       (scrollTop + windowHeight - elementOffset_42) /
    //       (windowHeight + $element_42.height() + 811);

    //     // Clamp the scrollPercent between 0 and 1
    //     scrollPercent = Math.min(1, Math.max(0, scrollPercent));

    //     // Apply the calculated opacity
    //     $element_42.css("opacity", scrollPercent);
    //   }

    //   // Call the function on scroll
    //   $(window).on("scroll", updateOpacity_42);
    // }

    // var $element_43 = $(".grinder-rack");

    // if ($element_43.length) {
    //   var elementOffset_43 = $element_43.offset().top; // Get the element's top offset

    //   // Function to update the opacity property on scroll
    //   function updateOpacity_43() {
    //     var scrollTop = $(window).scrollTop();
    //     var windowHeight = $(window).height();

    //     // Calculate scroll percentage (how much of the element is in view)
    //     var scrollPercent =
    //       (scrollTop + windowHeight - elementOffset_43) /
    //       (windowHeight + $element_43.height() + 811);

    //     // Clamp the scrollPercent between 0 and 1
    //     scrollPercent = Math.min(1, Math.max(0, scrollPercent));

    //     // Apply the calculated opacity
    //     $element_43.css("opacity", scrollPercent);
    //   }

    //   // Call the function on scroll
    //   $(window).on("scroll", updateOpacity_43);
    // }

   const $grinderRackOutline = $(".grinder-rack-outline");
   const $grinderRack = $(".grinder-rack");
    
   if ($grinderRackOutline.length && $grinderRack.length) {
      const elementTop = $grinderRackOutline.offset().top;
      const elementHeight = $grinderRackOutline.outerHeight();
  
      function updateOpacity() {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
    
        // Calculate visibility progress (0 to 1)
        const scrollStart = elementTop - windowHeight + 1300 ;
        const scrollEnd = elementTop + elementHeight + 811 ;
        let progress = (scrollTop - scrollStart) / (scrollEnd - scrollStart);
    
        // Clamp progress between 0 and 1
        progress = Math.min(1, Math.max(0, progress));
    
        // Apply calculated opacities
        $grinderRackOutline.css("opacity", 1 - progress);
        $grinderRack.css("opacity", progress);
      }
    
      // Throttle scroll events for better performance
      let isScrolling = false;
      $(window).on("scroll", function() {
        if (!isScrolling) {
          isScrolling = true;
          requestAnimationFrame(function() {
            updateOpacity();
            isScrolling = false;
          });
        }
      });
  
      updateOpacity(); // Initial check on page load
    }


    // var $image_5 = $(".full-set");
    // if ($image_5.length) {
    //   var elementOffset_2 = $image_5.offset().top;
    //   var imageHeight_2 = $image_5.height();

    //   var windowHeight = $(window).height(); // Get the window height

    //   // Function to check if the element is in the viewport
    //   function isInView(elementOffset, imageHeight) {
    //     var scrollTop = $(window).scrollTop();
    //     var scrollBottom = scrollTop + windowHeight;

    //     // Check if the element is in view (partially or fully)
    //     return (
    //       scrollBottom > elementOffset &&
    //       scrollTop < elementOffset + imageHeight
    //     );
    //   }

    //   // Function to apply the transformation
    //   function applyTransform() {
    //     // Check if $image_5 is in the viewport
    //     if (isInView(elementOffset_2, imageHeight_2)) {
    //       $image_5.css({
    //         opacity: "1",
    //         transform: "translate3d(0px, 0px, 0px)", // Move to original position
    //       });
    //     }
    //   }
    //   applyTransform();

    //   $(window).on("scroll", applyTransform);
    // }

    var $element_44 = $(".lets-listen--pepper-03");

    if ($element_44.length) {
      var elementOffset_44 = $element_44.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_44() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_44) /
          (windowHeight + $element_44.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 74.9895 * scrollPercent; // From -75px to 74.9895px

        // Apply the calculated transform immediately (no delay)
        $element_44.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_44);
    }

    var $element_45 = $(".lets-listen--pepper-02");

    if ($element_45.length) {
      var elementOffset_45 = $element_45.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_45() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_45) /
          (windowHeight + $element_45.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 99.988 * scrollPercent; // From -100px to 99.988px

        // Apply the calculated transform immediately (no delay)
        $element_45.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_45);
    }

    var $element_46 = $(".lets-listen--pepper-01");

    if ($element_46.length) {
      var elementOffset_46 = $element_46.offset().top; // Get the element's top offset

      // Function to update the transform property on scroll
      function updateTransform_46() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Calculate scroll percentage (how much of the element is in view)
        var scrollPercent =
          (scrollTop + windowHeight - elementOffset_46) /
          (windowHeight + $element_46.height() + 811);

        // Clamp the scrollPercent between 0 and 1
        scrollPercent = Math.min(1, Math.max(0, scrollPercent));

        // Calculate translateY value based on scrollPercent
        var translateY = 49.994 * scrollPercent; // From -50px to 49.994px

        // Apply the calculated transform immediately (no delay)
        $element_46.css(
          "transform",
          "translate3d(0px, " +
            translateY +
            "px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(96deg) skew(0deg, 0deg)"
        );
      }

      // Call the function on scroll
      $(window).on("scroll", updateTransform_46);
    }

    // Lottie Animation
    // Check if the #lottie-container element exists
    if ($("#lottie-container").length) {
      const animation = lottie.loadAnimation({
        container: $("#lottie-container")[0], // The container element
        renderer: "svg", // Renderer type: 'svg', 'canvas', 'html'
        loop: false, // Disable looping (we'll control it manually)
        autoplay: false, // Do not autoplay initially
        path: "https://cdn.shopify.com/s/files/1/0593/6503/2005/files/grinder-animation.json", // Path to your Lottie JSON file
      });

      let isScrolling;
      let lastScrollTop = 0;
      const speedMultiplier = 2.5;
      animation.setSpeed(speedMultiplier);

      // Function to handle scroll events
      function handleScroll() {
        const currentScrollTop = $(window).scrollTop();

        // Check if the element is in the viewport
        const container = document.querySelector("#lottie-container");
        const containerRect = container.getBoundingClientRect();

        // Play the animation only if the element is in the viewport
        if (
          containerRect.top < window.innerHeight &&
          containerRect.bottom >= 0
        ) {
          if (currentScrollTop > lastScrollTop) {
            // Scrolling down (top-to-bottom)
            animation.setDirection(1); // Play forward
            animation.play();
          } else if (currentScrollTop < lastScrollTop) {
            // Scrolling up (bottom-to-top)
            animation.setDirection(-1); // Play in reverse
            animation.play();
          }
        }

        // Update last scroll position
        lastScrollTop = currentScrollTop;

        // Clear the timeout if the user is still scrolling
        clearTimeout(isScrolling);

        // Set a timeout to pause the animation when scrolling stops
        isScrolling = setTimeout(() => {
          if (
            containerRect.top < window.innerHeight &&
            containerRect.bottom >= 0
          ) {
            animation.pause(); // Pause the animation when scrolling stops
          }
        }, 100); // Adjust the delay as needed
      }

      // Add scroll event listener using jQuery
      $(window).on("scroll", handleScroll);

      // IntersectionObserver to play the animation when the element is in the viewport
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // The element is in the viewport, start the animation
              animation.play();
            } else {
              // The element is not in the viewport, stop the animation
              animation.stop();
            }
          });
        },
        { threshold: 0.6 }
      ); // Trigger when 60% of the element is in the viewport

      // Start observing the container element
      observer.observe(document.querySelector("#lottie-container"));
    }
  }
});
